/*
 * Synchronous JavaScript and XML
 */

bq.ajaxQueue = function () {
    this.queue = [];
    this.keys = [];
    this.locks = [];
};

bq.ajaxQueue.prototype = {
    push: function (url, settings) {
        var queryKey = url;
        if (typeof (settings) !== 'undefined' && typeof (settings['queryKey']) !== 'undefined') {
            queryKey = settings['queryKey'];
            delete settings['queryKey'];
        }
        var key = this.keys.indexOf(queryKey);
        if (key < 0) {
            key = this.keys.length;
            this.keys.push(queryKey);
            this.queue.push([]);
        }
        this.queue[key].push({
            'url': url,
            'settings': $.extend({}, settings)
        });
        return key;
    },
    shift: function (key, force) {
        if ((!this.locks[key] || force) && (this.queue[key] && this.queue[key].length)) {
            this.locks[key] = this.locks[key] ? this.locks[key] + 1 : 1;
            var item = this.queue[key].shift();
            var url = item['url'];
            var settings = $.extend({}, item['settings'], {
                'complete': function () {
                    if (typeof (item['settings']['complete']) === 'function') {
                        item['settings']['complete'].apply(undefined, arguments);
                    }
                    this.locks[key]--;
                    this.shift(key);
                }.bind(this)
            });
            $.ajax(url, settings);
        }
    }
};

var ajaxQueue = new bq.ajaxQueue();
$.sjax = function (url, settings) {
    var key = ajaxQueue.push(url, settings);
    ajaxQueue.shift(key);
};
